import { Box } from '@mui/material';
import Table, { Column } from '../../../core-components/theme/components/Table/Table';
import NoDataView from '../../../globalComponents/NoDataView/NoDataView';
import { DataLoggerTableColumns } from '../helpers/DataLoggerTableColumns';
import { useDataLoggerTable } from '../hooks/useDataLoggerTable';
import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface DataLoggerTableProps {
  searchString: string;
  isPending?: boolean;
  onEditClick: (id: string) => void;
}

export default function DataLoggerTable({
  searchString,
  isPending,
  onEditClick,
}: DataLoggerTableProps) {
  const { t } = useTranslation();
  const {
    dataLoggers = [],
    tableContainerRef,
    lastElementRef
  } = useDataLoggerTable(searchString);
  const columns = useMemo(() => DataLoggerTableColumns(t, onEditClick) as Column[], [t, onEditClick]);
  const hasNoData = !isPending && (!dataLoggers || dataLoggers.length === 0);

  return (
    <Box
      ref={tableContainerRef}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        height: { xs: '76vh', md: '70vh' },
        opacity: isPending ? '0.3' : '1',
      }}
    >
      {hasNoData ? (
        <NoDataView message={t('common.noDataAvailable', 'No data available')} />
      ) : (
        <Table
          stickyHeader
          rows={dataLoggers}
          columns={columns}
          lastRowRef={lastElementRef}
        />
      )}
    </Box>
  );
} 